module.exports = __webpack_public_path__ + "img/ssd.eb289921.svg";